import { Icon, message } from 'antd'
import api from 'api'
import React, { useContext, useState } from 'react'

import { AppPageLayoutDesigerContext } from './AppPageLayoutDesigerContext'

export const AppPageLayoutHeardDesiger = () => {
	return (
		<div className="app-page-layout-heard-desiger">
			<Breadcrumbs />
			<Views />
			<Actions />
		</div>
	)
}

const Breadcrumbs = () => {
	return <div className="app-page-layout-heard-item"></div>
}

const Views = () => {
	const context = useContext(AppPageLayoutDesigerContext)
	const views = [{ name: '页面布局', icon: 'qcciconfont-navicon-dphf' }]
	const [showLayoutMenu, setShowLayoutMenu] = useState(false)
	const chgShowLayoutMenu = (e: any) => {
		if (!showLayoutMenu) {
			e.nativeEvent.stopImmediatePropagation()
			e.stopPropagation()
			document.onclick = () => {
				setShowLayoutMenu(false)
				document.onclick = null
			}
		} else {
			document.onclick = null
		}
		setShowLayoutMenu(!showLayoutMenu)
	}
	return (
		<div className="app-page-layout-heard-item">
			<div className="app-page-layout-heard-item-views">
				{views.map((view: any) => {
					return (
						<div
							key={view.name}
							onClick={e => {
								chgShowLayoutMenu(e)
								context.chgView(view.name)
							}}
							className={`app-page-layout-heard-item-view ${context.view === view.name ? 'active' : ''}`}
						>
							<div className="app-page-layout-heard-item-view-icon">
								{view.icon !== '' ? <i className={view.icon}></i> : ''}
							</div>
							<div className="app-page-layout-heard-item-view-label">{view.name}</div>
							{showLayoutMenu ? <LayoutMenu /> : ''}
						</div>
					)
				})}
			</div>
		</div>
	)
}

const Actions = () => {
	const context = useContext(AppPageLayoutDesigerContext)
	const save = async () => {
		let res = await api.modeling.apppage.save(context.appPage)
		if (res) {
			message.success('保存成功！')
			if (!context.appPage.id) {
				window.location.href = window.location.href + `&id=${res.id}`
			} else {
				window.location.href = window.location.href
			}
		} else {
			message.error('保存失败！')
		}
	}
	const preview = () => {
		if (!context.appPage.id) {
			message.warn('请先保存！')
			return
		}
		window.open(`/std/${context.appPage.application}/appPage/${context.appPage.id}`)
	}
	return (
		<div className="app-page-layout-heard-item">
			<div className="app-page-layout-heard-actions">
				<button className="app-page-layout-heard-actions-item" onClick={preview}>
					<Icon type="eye" className="app-page-layout-heard-icon-preview"></Icon>预览
				</button>
				<button className="app-page-layout-heard-actions-item" onClick={save}>
					<Icon type="save" className="app-page-layout-heard-icon-save"></Icon>保存
				</button>
			</div>
		</div>
	)
}

const LayoutMenu = () => {
	const context = useContext(AppPageLayoutDesigerContext)
	const chgLayoutType = (layoutType: number) => {
		let appPage = context.appPage
		appPage.layoutType = layoutType
		context.setAppPage({ ...appPage })
	}
	return (
		<div className="layout-menu" style={{ transformOrigin: 'center top', zIndex: 2051 }}>
			<div className="page-layout-select">
				<div className="page-layout-select-items">
					<div className="page-layout-select-item" onClick={e => chgLayoutType(1)}>
						<div className="page-layout-select-item-thumb">
							<div className="page-layout-select-thumb">
								<div className="page-layout-select-thumb-row" style={{ flex: '1 1 0%' }}>
									<div className="page-layout-select-thumb-cell" style={{ flex: '1 1 0%' }}>
										<div className="page-layout-select-thumb-cell-inner"></div>
									</div>
								</div>
							</div>
						</div>
						<div className="page-layout-select-item-label">一列</div>
						<div className="page-layout-select-item-desc">全屏单一主区域</div>
					</div>
					<div className="page-layout-select-item" onClick={e => chgLayoutType(2)}>
						<div className="page-layout-select-item-thumb">
							<div className="page-layout-select-thumb">
								<div className="page-layout-select-thumb-row" style={{ flex: '1 1 0%' }}>
									<div className="page-layout-select-thumb-cell is-fixed" style={{ width: '32%' }}>
										<div className="page-layout-select-thumb-cell-inner"></div>
									</div>
									<div className="page-layout-select-thumb-cell" style={{ flex: '1 1 0%' }}>
										<div className="page-layout-select-thumb-cell-inner"></div>
									</div>
								</div>
							</div>
						</div>
						<div className="page-layout-select-item-label">左侧栏</div>
						<div className="page-layout-select-item-desc">左边定宽一栏，右边自适应宽度一列</div>
					</div>
				</div>
			</div>
		</div>
	)
}



// WEBPACK FOOTER //
// ./src/modules/modeling/page/AppPageLayoutDesiger/AppPageLayoutHeardDesiger.tsx